import React from 'react'
import { IconSVGType } from '../../../types/icons'

/**
 * @param {IconSVGType} props
 */
const FileCSVIcon = (props: IconSVGType) => {
  return (
    <svg
      className={props.className}
      fill='none'
      height={props.height}
      viewBox={props.viewBox || '0 0 24 24'}
      width={props.width}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fill='#5D5D5D'
        fillRule='evenodd'
        d='M4.01 4c0-1.1.89-2 1.99-2h7.17c.53 0 1.04.21 1.41.59l4.83 4.83c.38.37.59.88.59 1.41V20c0 1.1-.9 2-2 2H5.99C4.89 22 4 21.1 4 20l.01-16ZM13 3.5V8c0 .55.45 1 1 1h4.5L13 3.5ZM9.705 16.125c-.357.525-.938.973-1.89.973-1.225 0-2.275-.924-2.275-2.478v-.119c0-1.526 1.05-2.499 2.331-2.499.833 0 1.414.364 1.806.924l-1.022.938c-.154-.245-.378-.462-.756-.462-.476 0-.819.406-.819 1.127v.028c0 .777.371 1.141.826 1.141.392 0 .616-.224.777-.476l1.022.903Zm4.159-.651c0 .987-.77 1.61-1.925 1.61-.826 0-1.575-.231-2.17-.721l.728-1.085c.469.357.994.546 1.456.546.273 0 .378-.098.378-.231v-.014c0-.147-.147-.231-.595-.364-.98-.294-1.736-.637-1.736-1.575v-.028c0-.924.7-1.596 1.883-1.596.742 0 1.358.168 1.918.602l-.707 1.099c-.357-.259-.82-.441-1.232-.441-.224 0-.336.098-.336.217v.014c0 .147.147.231.63.385 1 .273 1.708.658 1.708 1.561v.021Zm3.154 1.554H15.52L13.868 12.1h1.652l.763 2.723.763-2.723h1.624l-1.652 4.928Z'
        clipRule='evenodd'
      />
    </svg>
  )
}

export default FileCSVIcon
